import React from "react";
import { TrendingUp, Home, Euro, Calculator } from "lucide-react";

const fmtEuro = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
const fmtNum = (n) => new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 }).format(n || 0);

// Airbnb-style stat card: airy card, minimal linear icon aligned with the label
// (no chip/circle background — icon lives inline next to the value).
const StatCard = ({ label, value, hint, icon: Icon, accent = "#111827" }) => (
  <div className="ios-card p-5">
    <div className="flex items-center gap-2 text-slate-500">
      <Icon className="w-4 h-4" strokeWidth={1.5} style={{ color: accent }} />
      <span className="text-[10px] uppercase tracking-[0.18em] font-semibold">{label}</span>
    </div>
    <div className="font-display font-bold text-2xl mt-2 leading-none text-slate-900">{value}</div>
    {hint && <div className="text-[11px] text-slate-500 mt-1.5">{hint}</div>}
  </div>
);

const StatsBar = ({ stats, filtersActive }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
    <StatCard
      label="Immobili filtrati"
      value={fmtNum(stats.count)}
      hint={filtersActive ? "Sul filtro corrente" : "Totale in archivio"}
      icon={Home}
      accent="#111827"
    />
    <StatCard
      label="Prezzo medio"
      value={fmtEuro(stats.avg_prezzo)}
      hint={stats.count > 0 ? `Min ${fmtEuro(stats.min_prezzo)} · Max ${fmtEuro(stats.max_prezzo)}` : "—"}
      icon={Euro}
      accent="#007AFF"
    />
    <StatCard
      label="€ / m² medio"
      value={fmtEuro(stats.avg_eur_mq)}
      hint={stats.count > 0 ? `Su ${fmtNum(stats.avg_mq)} m² medi` : "—"}
      icon={Calculator}
      accent="#111827"
    />
    <StatCard
      label="Valore totale"
      value={fmtEuro(stats.total_prezzo)}
      hint="Somma dei prezzi filtrati"
      icon={TrendingUp}
      accent="#34C759"
    />
  </div>
);

export default StatsBar;
